// =========================
// ✅ CART DRAWER - WITH DYNAMIC VARIANT PRICE UPDATES
// =========================

(function () {
  let cartUpdating = false;
  let drawerInitialized = false;
  const MAX_QTY_PER_PRODUCT = 4; // Global maximum per product

  // --- Ensure Shopify Routes Exist ---
  if (!window.routes || !window.routes.cart_url) {
    window.routes = {
      cart_add_url: "/cart/add.js",
      cart_update_url: "/cart/update.js",
      cart_change_url: "/cart/change.js",
      cart_url: "/cart",
    };
  }

  // --- Get Current Cart Data ---
  async function getCartData() {
    try {
      const res = await fetch("/cart.js", { 
        headers: { 
          "Accept": "application/json",
          "Cache-Control": "no-cache"
        } 
      });
      const text = await res.text();
      if (!text || text.trim().startsWith("<")) return null;
      return JSON.parse(text);
    } catch (err) {
      console.error("🧨 getCartData failed:", err);
      return null;
    }
  }

  // --- Check if Product Already in Cart ---
  async function getProductQuantityInCart(variantId) {
    const cart = await getCartData();
    if (!cart || !cart.items) return 0;
    
    const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId));
    return existingItem ? existingItem.quantity : 0;
  }

  // --- Show Quantity Limit Message ---
  function showQuantityLimitMessage() {
    // Remove existing message if any
    const existingMsg = document.querySelector('.quantity-limit-message');
    if (existingMsg) existingMsg.remove();
    
    const message = document.createElement('div');
    message.className = 'quantity-limit-message';
    message.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #ff4444;
      color: white;
      padding: 12px 16px;
      border-radius: 4px;
      z-index: 10000;
      font-size: 14px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      max-width: 300px;
    `;
    
    message.innerHTML = `
      <strong>You can only upto ${MAX_QTY_PER_PRODUCT} </strong><br>
       Quantities of this product.
    `;
    
    document.body.appendChild(message);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      if (message.parentNode) message.parentNode.removeChild(message);
    }, 3000);
  }

  // --- Update Cart Count ---
  async function updateCartItemCount(count = null) {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      const text = await res.text();
      if (!text || text.trim().startsWith("<")) return;

      const cart = JSON.parse(text);
      const itemCount = count !== null ? count : cart.item_count;

      document.querySelectorAll(".cart-count-bubble").forEach((el) => {
        el.textContent = itemCount;
        el.style.display = itemCount > 0 ? "inline-block" : "block";
      });
    } catch (err) {
      console.error("🧨 Cart count update failed:", err);
    }
  }

  // --- Open Drawer ---
  function openCartDrawer() {
    const drawer = document.querySelector(".f-cart-drawer");
    if (!drawer) return;
    drawer.classList.add("f-cart-drawer--active");
    document.body.classList.remove(
      "modal--open",
      "modal-quickview--open",
      "overflow-hidden"
    );
    const quickview = document.querySelector(".ar_new_quickview");
    if (quickview) quickview.classList.remove("modal--active");
  }

  // --- Close Drawer ---
  function closeCartDrawer() {
    const drawer = document.querySelector(".f-cart-drawer");
    if (drawer) drawer.classList.remove("f-cart-drawer--active");
  }

  // --- Update Drawer ---
  async function updateCartDrawer(showAfterLoad = false) {
    try {
      const drawer = document.querySelector(".f-cart-drawer");
      if (!drawer) return;

      const upsell = drawer.querySelector(".f-upsale-row");
      if (upsell) upsell.innerHTML = `<div class="loader"></div>`;

      const res = await fetch(
        `${window.routes.cart_url}?section_id=cart-drawer&t=${Date.now()}`
      );
      const html = document.createElement("div");
      html.innerHTML = await res.text();
      const newDrawer = html.querySelector(".f-cart-drawer");
      if (!newDrawer) return;

      drawer.innerHTML = newDrawer.innerHTML;

      await new Promise((r) => setTimeout(r, 150));
      initializeDrawerListeners();

      if (showAfterLoad) {
        openCartDrawer();
        setTimeout(() => initializeDrawerListeners(), 200);
      }

      window.dispatchEvent(new CustomEvent("cart:drawer:updated"));
    } catch (err) {
      console.error("🧨 updateCartDrawer failed:", err);
    }
  }

  // --- Initialize Drawer Listeners ---
  function initializeDrawerListeners() {
    console.log("🔄 Initializing drawer listeners...");
    addCloseListeners();
    addQuantityListeners();
    addRemoveListeners();
    addUpsellListeners();
    bindVariantSelectors(); // This now includes price updates
    setTimeout(() => initializeSlickSlider(), 300);
    drawerInitialized = true;
  }

  // --- Close Button ---
  function addCloseListeners() {
    const closeBtn = document.querySelector(".f-cart-drawer-header-right-close");
    if (closeBtn) {
      const newBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newBtn, closeBtn);

      newBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeCartDrawer();
      });
    }

    const drawer = document.querySelector(".f-cart-drawer");
    const box = document.querySelector(".f-cart-drawer-box");

    if (drawer)
      drawer.addEventListener("click", (e) => {
        if (e.target.classList.contains("f-cart-drawer")) closeCartDrawer();
      });

    if (box) box.addEventListener("click", (e) => e.stopPropagation());
  }

  // --- Quantity Buttons ---
  function addQuantityListeners() {
    document
      .querySelectorAll(".f-cart-drawer-quantity-selector button")
      .forEach((button) => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener("click", async () => {
          if (cartUpdating) return;
          cartUpdating = true;

          const root = newButton.closest("[data-line-item-key]");
          if (!root) return (cartUpdating = false);

          const key = root.getAttribute("data-line-item-key");
          const input = newButton.parentElement.querySelector("input");
          const isPlus =
            newButton.classList.contains(
              "f-cart-drawer-quantity-selector-plus"
            );
          const newQty = isPlus
            ? Number(input.value) + 1
            : Number(input.value) - 1;

          // Enforce maximum quantity
          if (newQty > MAX_QTY_PER_PRODUCT) {
            showQuantityLimitMessage();
            cartUpdating = false;
            return;
          }

          if (newQty < 0) {
            cartUpdating = false;
            return;
          }

          const spinner = newButton.querySelector(".qty-spinner");
          const icon = newButton.querySelector("svg");
          if (spinner) spinner.classList.remove("hidden");
          if (icon) icon.classList.add("hidden");

          try {
            const res = await fetch(window.routes.cart_update_url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ updates: { [key]: newQty } }),
            });
            const cart = await res.json();
            await updateCartItemCount(cart.item_count);
            await updateCartDrawer(true);
          } catch (err) {
            console.error("🧨 Quantity update failed:", err);
          } finally {
            if (spinner) spinner.classList.add("hidden");
            if (icon) icon.classList.remove("hidden");
            cartUpdating = false;

            setTimeout(() => applyMaxQtyState(), 300);
          }
        });
      });

    applyMaxQtyState();
    console.log("✅ Quantity listeners added");
  }

  function applyMaxQtyState() {
    document
      .querySelectorAll(".f-cart-drawer-quantity-selector")
      .forEach((selector) => {
        const input = selector.querySelector("input");
        const plusBtn = selector.querySelector(
          ".f-cart-drawer-quantity-selector-plus"
        );

        if (!input || !plusBtn) return;

        const qty = Number(input.value);
        if (qty >= MAX_QTY_PER_PRODUCT) {
          plusBtn.classList.add("max-reached");
          plusBtn.disabled = true;
        } else {
          plusBtn.classList.remove("max-reached");
          plusBtn.disabled = false;
        }
      });
  }

  // --- Remove Item ---
  function addRemoveListeners() {
    document.querySelectorAll(".f-remove-item").forEach((button) => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", async (e) => {
        e.preventDefault();

        const key = newButton
          .closest("[data-line-item-key]")
          ?.getAttribute("data-line-item-key");
        if (!key) return;

        const spinner = newButton.querySelector(".qty-spinner");
        const text = newButton.querySelector(".remove-text");
        if (spinner) spinner.classList.remove("hidden");
        if (text) text.classList.add("hidden");

        try {
          const res = await fetch(window.routes.cart_update_url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ updates: { [key]: 0 } }),
          });

          const cart = await res.json();
          await updateCartItemCount(cart.item_count);
          await updateCartDrawer(true);
        } catch (err) {
          console.error("🧨 Remove item failed:", err);
        } finally {
          if (spinner) spinner.classList.add("hidden");
          if (text) text.classList.remove("hidden");
        }
      });
    });

    console.log("✅ Remove listeners added");
  }

  // --- Upsell Add ---
  function addUpsellListeners() {
    document.querySelectorAll(".add.f-upsale-add").forEach((button) => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", async (e) => {
        e.preventDefault();

        const variantId = newButton.getAttribute("data-variant-id");
        if (!variantId) return;

        // Check current quantity in cart
        const currentQty = await getProductQuantityInCart(variantId);
        if (currentQty >= MAX_QTY_PER_PRODUCT) {
          showQuantityLimitMessage();
          return;
        }

        const spinner = newButton.querySelector(".qty-spinner");
        const label = newButton.querySelector(".add-text");
        if (spinner) spinner.classList.remove("hidden");
        if (label) label.classList.add("hidden");

        try {
          const formData = new FormData();
          formData.append("id", variantId);
          formData.append("quantity", 1);

          await fetch(window.routes.cart_add_url, {
            method: "POST",
            body: formData,
          });

          await updateCartItemCount();
          await updateCartDrawer(true);
        } catch (err) {
          console.error("🧨 Upsell add failed:", err);
        } finally {
          if (spinner) spinner.classList.add("hidden");
          if (label) label.classList.remove("hidden");
        }
      });
    });

    console.log("✅ Upsell listeners added");
  }

  // --- Variant Change with Price Updates ---
  function bindVariantSelectors() {
    document
      .querySelectorAll(
        ".f-upsale-main select, .variant_selector_cart, .variant_selector_cart_list"
      )
      .forEach((select) => {
        const newSelect = select.cloneNode(true);
        select.parentNode.replaceChild(newSelect, select);

        newSelect.addEventListener("change", (e) => {
          const selectedOption = e.target.options[e.target.selectedIndex];
          const variantPrice = selectedOption.getAttribute('data-price');
          const variantComparePrice = selectedOption.getAttribute('data-compare-price');
          
          // Update the button data attribute
          const parent = newSelect.closest(".f-upsale-main");
          const btn = parent?.querySelector(".f-upsale-add");
          if (btn) btn.setAttribute("data-variant-id", newSelect.value);
          
          // Update prices in the UI
          updateUpsellPrices(parent, variantPrice, variantComparePrice);
        });
      });

    console.log("✅ Variant selectors with price updates bound");
  }

  // --- Update Upsell Product Prices ---
  function updateUpsellPrices(parentElement, price, comparePrice) {
    if (!parentElement) return;
    
    // Find price elements within this upsell product
    const priceSection = parentElement.querySelector('.price-section');
    if (!priceSection) return;
    
    const actualPriceEl = priceSection.querySelector('.actual-price');
    const discountPriceEl = priceSection.querySelector('.discount-price');
    
    // Update actual price
    if (actualPriceEl) {
      actualPriceEl.textContent = price;
    }
    
    // Update compare price (show/hide based on availability)
    if (discountPriceEl) {
      if (comparePrice && comparePrice !== 'null' && comparePrice !== price) {
        discountPriceEl.textContent = comparePrice;
        discountPriceEl.style.display = 'inline';
      } else {
        discountPriceEl.style.display = 'none';
      }
    }
  }



  // --- Wait For Drawer ---
  function waitForDrawer() {
    return new Promise((resolve) => {
      if (document.querySelector(".f-cart-drawer")) return resolve(true);

      const observer = new MutationObserver((_, obs) => {
        if (document.querySelector(".f-cart-drawer")) {
          obs.disconnect();
          resolve(true);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        resolve(false);
      }, 5000);
    });
  }

  // --- Smart Add to Cart Handler ---
  async function handleAddToCart(variantId, quantity = 1) {
    // Check current quantity in cart
    const currentQty = await getProductQuantityInCart(variantId);
    const totalAfterAdd = currentQty + quantity;
    
    if (totalAfterAdd > MAX_QTY_PER_PRODUCT) {
      showQuantityLimitMessage();
      return false;
    }
    
    return true;
  }

  // --- Initialize On Load ---
  async function initializeOnLoad() {
    console.log("🚀 Cart drawer script loaded");

    await waitForDrawer();
    const drawer = document.querySelector(".f-cart-drawer");
    if (drawer) initializeDrawerListeners();

    //
    // --- PDP: Product-Form Add To Cart ---
    //
    document.querySelectorAll(".product-form__submit").forEach((btn) => {
      const newBtn = btn.cloneNode(true);
      btn.replaceWith(newBtn);

      // stop Shopify default handler
      newBtn.addEventListener("click", (e) => e.stopImmediatePropagation(), true);

      newBtn.addEventListener("click", async (e) => {
        e.preventDefault();

        const form = newBtn.closest("form");
        if (!form || !form.action.endsWith("/cart/add")) return;

        // Get variant ID from form and validate
        const formData = new FormData(form);
        const variantId = formData.get('id');
        
        if (variantId) {
          const canAdd = await handleAddToCart(variantId, 1);
          if (!canAdd) return;
        }

        const spinner = newBtn.querySelector(".btn-spinner");
        if (spinner) spinner.classList.remove("hidden");

        try {
          await fetch(window.routes.cart_add_url, {
            method: "POST",
            body: formData,
          });

          await updateCartDrawer(true);
          await updateCartItemCount();
        } catch (err) {
          console.error("🧨 Add to cart failed:", err);
        } finally {
          if (spinner) spinner.classList.add("hidden");
        }
      });
    });

    //
    // --- QUICK ADD (Collection/Grid) ---
    //
    document.querySelectorAll(".quick-add__submit").forEach((btn) => {
      const newBtn = btn.cloneNode(true);
      btn.replaceWith(newBtn);

      newBtn.addEventListener("click", (e) => e.stopImmediatePropagation(), true);

      newBtn.addEventListener("click", async (e) => {
        e.preventDefault();

        const form = newBtn.closest("form");
        if (!form) return;

        // Get variant ID from form and validate
        const formData = new FormData(form);
        const variantId = formData.get('id');
        
        if (variantId) {
          const canAdd = await handleAddToCart(variantId, 1);
          if (!canAdd) return;
        }

        try {
          await fetch(window.routes.cart_add_url, {
            method: "POST",
            body: formData,
          });

          await updateCartDrawer(true);
          await updateCartItemCount();
        } catch (err) {
          console.error("🧨 Quick Add failed:", err);
        }
      });
    });

    //
    // --- Custom AKS Add To Cart ---
    //
    document.body.addEventListener("click", async (e) => {
      const btn = e.target.closest(".aks_add-to-cart");
      if (!btn || !btn.classList.contains("aks_add-to-cart")) return;

      e.stopImmediatePropagation();
      e.preventDefault();

      let variantId = btn.getAttribute("data-id");
      if (!variantId) return;

      // Validate quantity before adding
      const canAdd = await handleAddToCart(variantId, 1);
      if (!canAdd) return;

      btn.classList.add("loading");

      const spinner = btn.querySelector(".btn-spinner");
      const icon = btn.querySelector(".btn-icon");

      if (icon) icon.classList.add("hidden");
      if (spinner) spinner.classList.remove("hidden");

      const productCard = btn.closest(".aks_grid-product");
      if (productCard) {
        const variantSelect = productCard.querySelector(".aks_variant-selector");
        if (variantSelect && variantSelect.value)
          variantId = variantSelect.value;
      }

      try {
        await fetch(window.routes.cart_add_url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        await new Promise((r) => setTimeout(r, 400));
        await updateCartDrawer(true);
        await updateCartItemCount();
      } catch (err) {
        console.error("🧨 Custom Add To Cart failed:", err);
      } finally {
        if (spinner) spinner.classList.add("hidden");
        if (icon) icon.classList.remove("hidden");
        btn.classList.remove("loading");
      }
    });

    // Cart Icon Click
    document.querySelectorAll(".cart-icon-bubble").forEach((a) => {
      a.addEventListener("click", async (e) => {
        e.preventDefault();
        openCartDrawer();
        await updateCartDrawer(true);
        await updateCartItemCount();
      });
    });

    updateCartItemCount();
    setInterval(updateCartItemCount, 10000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeOnLoad);
  } else {
    initializeOnLoad();
  }

  window.addEventListener("cart:drawer:updated", () => updateCartItemCount());

  window.initializeDrawerListeners = initializeDrawerListeners;
})();